import gql from 'graphql-tag';

export const FISKALY_SIGN_INFO_QUERY = gql`
  query fiskalyIntegration {
    fiskalyIntegration {
      apiKey
      apiSecret
      system {
        deviceFingerprint
        state
        uuid
      }
    }
  }
`;

export const DECOMMISSION_SYSTEM_MUTATION = gql`
  mutation decommissionSystem($input: DecommissionSystemInput!) {
    decommissionSystem(input: $input) {
      success
    }
  }
`;
